import { Menu as MenuCore, MenuBtn, MenuList } from '@studiometa/ui';
import { withResponsiveOptions } from '@studiometa/js-toolkit';

/**
 * Menu Class
 */
export default class Menu extends withResponsiveOptions(MenuCore) {
  static config = {
    name: 'Menu',
    components: {
      Menu,
      MenuBtn,
      MenuList,
    },
    options: {
      ...MenuCore.config.options,
      mode: {
        ...MenuCore.config.options.mode,
        responsive: true,
      },
    },
    emits: ['enter', 'leave'],
  };

  /**
   * onMouseenter
   */
  onMouseenter() {
    this.$emit('enter');
  }

  /**
   * onMouseleave
   */
  onMouseleave() {
    this.$emit('leave');
  }

  /**
   * toggle
   */
  toggle() {
    super.toggle();
    document.body.classList.toggle('is-menu-open', this.menuList.isOpen);
  }
}
